var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mainAuxPage zj-flex-column",
      staticStyle: { padding: "0 12px" },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            flex: "4",
            "margin-top": "7px",
            "margin-bottom": "5px",
          },
        },
        [
          _vm.isTeacher || _vm.isAdmin || _vm.isDeveloper
            ? _c("teacherTopPage", { ref: "teacherTopPage" })
            : _c("studentTopPage", { ref: "studentTopPage" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            flex: "3",
            "margin-top": "7px",
            "margin-bottom": "5px",
          },
        },
        [_c("mainBottomPage", { ref: "mainBottomPage" })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }